import { theme } from '~/shared/styles/theme';

const CheckmarkCircleFilled = () => {
  return (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="22.5"
        cy="22.5"
        r="22.5"
        fill={theme.palette.custom.textTitle}
      />
      <path
        d="M32.25 14 17.375 31 11 24.625"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckmarkCircleFilled;
